<template>
	<div class="encart-facebook">
		<span class="title">
			<span class="first-line">Nos derniers posts</span>
			<span class="second-line">Facebook</span>
		</span>
		<div class="facebook-posts">
			<div class="fb-post" v-for="post in postsFb" :key="post.id">
				<span class="titre">{{post.title}}</span>
				<span class="date">{{post.date}}</span>
				<div class="texte">{{post.texte}}</div>
			</div>
		</div>
		<a href="https://www.facebook.com/greta.paysdelaloire/" class="facebook-btn">
			Retrouvez-nous sur Facebook
			<i class="fa fa-facebook" aria-hidden="true"></i>
		</a>
	</div>
</template>

<script>
/**
 * Composant permettant d'afficher l'encart facebook de la sidebar
 *
 * @version 1.0.0
 */
export default {
	name: 'EncartFacebook',
	props: {},
	data() {
		return {
			postsFb: [
				{
					title: 'Greta-CFA Pays de la Loire',
					id: 123,
					date: '1 juillet, 11:04',
					texte:
						"Vous êtes demandeur d'emploi, salarié, intérimaire et vous avez fait le choix d'un nouvel avenir professionnel ? <br> Le GRETA vous informe sur les 10 jours à venir sur les formations possibles sur Saint-Nazaire, tous secteurs d'activité confondus… ",
				},
				{
					title: 'Greta-CFA Pays de la Loire',
					id: 124,
					date: '1 juillet, 11:04',
					texte:
						"Vous êtes demandeur d'emploi, salarié, intérimaire et vous avez fait le choix d'un nouvel avenir professionnel ? <br> Le GRETA vous informe sur les 10 jours à venir sur les formations possibles sur Saint-Nazaire, tous secteurs d'activité confondus… ",
				},
				{
					title: 'Greta-CFA Pays de la Loire',
					id: 134,
					date: '1 juillet, 11:04',
					texte:
						"Vous êtes demandeur d'emploi, salarié, intérimaire et vous avez fait le choix d'un nouvel avenir professionnel ? <br> Le GRETA vous informe sur les 10 jours à venir sur les formations possibles sur Saint-Nazaire, tous secteurs d'activité confondus… ",
				},
				{
					title: 'Greta-CFA Pays de la Loire',
					id: 234,
					date: '1 juillet, 11:04',
					texte:
						"Vous êtes demandeur d'emploi, salarié, intérimaire et vous avez fait le choix d'un nouvel avenir professionnel ? <br> Le GRETA vous informe sur les 10 jours à venir sur les formations possibles sur Saint-Nazaire, tous secteurs d'activité confondus… ",
				},
			],
		};
	},
	mounted() {},
	methods: {},
	components: {},
};
</script>

<style lang="scss" scoped>
@import '~@scss/style.scss';

.encart-facebook {
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;
	max-height: 880px;
	padding-top: 40px;
	background-color: #fff;
	border-radius: 15px;
}

.title {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	.first-line {
		font-size: 20px;
		line-height: 20px;
		color: $secondaryColor;
	}

	.second-line {
		font-size: 30px;
		line-height: 25px;
		font-weight: bold;
		font-style: italic;
		color: $mainColor;
	}
}

.facebook-posts {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin-top: 40px;
	padding: 80px 20px;
	overflow-y: scroll;

	.fb-post {
		width: 100%;
		padding: 40px 25px;
		border-radius: 15px;
		background-color: #fff;
		box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);

		+ .fb-post {
			margin-top: 20px;
		}

		.titre {
			display: block;
			font-size: 17px;
			line-height: 22px;
			color: $secondaryColor;
		}

		.date {
			display: block;
			font-size: 15px;
			line-height: 22px;
		}

		.texte {
			margin-top: 25px;
			font-size: 15px;
			line-height: 22px;

			a {
				color: $secondaryColor;
			}
		}
	}
}

.facebook-btn {
	display: flex;
	justify-content: space-around;
	align-items: center;
	position: absolute;
	bottom: -25px;
	left: 0;
	width: 100%;
	height: 80px;
	padding: 0 20px;
	border-radius: 10px;
	font-size: 17px;
	line-height: 20px;
	background-color: #3b5998;
	color: white;

	i {
		font-size: 35px;
		line-height: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/EncartFacebook.vue